import BaseService from '@/ecm/common/BaseService.js';
class GoogleCloudService {
  baseUrl = 'google-cloud';
  getGoogleCloudOAuthUrl = () => BaseService.get({ url: `${this.baseUrl}/oauth-url` });
  getGoogleCloudToken = () => BaseService.get({ url: `${this.baseUrl}/token` });
}

export default new GoogleCloudService();